export const treandingNewsCategoryTab = [
  {
    id: 1,
    name: "All",
  },
  {
    id: 2,
    name: "Travel",
  },
  {
    id: 6,
    name: "Entertainment",
  },
  {
    id: 3,
    name: "Sport",
  },
  {
    id: 4,
    name: "Health",
  },
  {
    id: 5,
    name: "Nature",
  },
];

// Navigation menu items array
export const navigationItems = [
  {
    id: 1,
    name: "Ballina",
    path: "/",
    isHome: true,
  },
  {
    id: 2,
    name: "Lajme",
    path: "/category/lajme",
    category: "lajme",
  },
  {
    id: 3,
    name: "Politikë",
    path: "/category/politikë",
    category: "politikë",
  },
  {
    id: 4,
    name: "Ekonomi",
    path: "/category/ekonomi",
    category: "ekonomi",
  },
  {
    id: 5,
    name: "Sport",
    path: "/category/sport",
    category: "sport",
  },
  {
    id: 6,
    name: "Kulturë",
    path: "/category/kulturë",
    category: "kulturë",
  },
  {
    id: 7,
    name: "Teknologji",
    path: "/category/teknologji",
    category: "teknologji",
  },
  {
    id: 8,
    name: "Lifestyle",
    path: "/category/lifestyle",
    category: "lifestyle",
  },
  {
    id: 9,
    name: "Shëndetësi",
    path: "/category/shëndetësi",
    category: "shëndetësi",
  },
  {
    id:10,
    name:'Na Kontaktoni',
    path:'/contact'
  },
];

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
